"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const APPLICATIONS_IMAGE =
	"/image/new-version/casting/High-Pressure-Die-Casting/high-pressure-die-casting-applications.webp";

const ITEM_KEYS = [
	{
		title: "hpdcApplicationsItem1Title",
		desc: "hpdcApplicationsItem1Desc",
	},
	{
		title: "hpdcApplicationsItem2Title",
		desc: "hpdcApplicationsItem2Desc",
	},
	{
		title: "hpdcApplicationsItem3Title",
		desc: "hpdcApplicationsItem3Desc",
	},
	{
		title: "hpdcApplicationsItem4Title",
		desc: "hpdcApplicationsItem4Desc",
	},
	{
		title: "hpdcApplicationsItem5Title",
		desc: "hpdcApplicationsItem5Desc",
	},
] as const;

export default function HighPressureCastingApplications() {
	const t = useTranslations("new-high-pressure-casting");

	return (
		<section className="bg-[#ffffff] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid items-stretch gap-8 lg:grid-cols-2 lg:gap-10 xl:gap-12">
					<div className="flex min-w-0 flex-col">
						<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
							{t("hpdcApplicationsTitle")}
						</h2>
						<p className="mt-3 text-sm leading-relaxed text-black sm:mt-4 md:text-base">
							{t("hpdcApplicationsDesc")}
						</p>

						<div className="mt-6 grid gap-x-8 gap-y-6 sm:mt-8 sm:grid-cols-2 sm:gap-y-8">
							{ITEM_KEYS.map((item, index) => (
								<div
									key={item.title}
									className={`min-w-0 ${index === ITEM_KEYS.length - 1 ? "sm:col-span-2" : ""}`}
								>
									<h3 className="text-base font-semibold leading-snug text-themePrimary400 sm:text-lg">
										<span
											className="mr-3 inline-block h-[1em] w-0.5 translate-y-0.5 rounded-full bg-themePrimary400 align-baseline"
											aria-hidden
										/>
										{t(item.title)}
									</h3>
									<p className="mt-2 text-sm leading-relaxed text-black md:text-base">{t(item.desc)}</p>
								</div>
							))}
						</div>
					</div>

					<div className="relative aspect-[4/3] min-h-[240px] w-full overflow-hidden bg-gray-200 lg:aspect-auto lg:min-h-0 lg:min-h-full">
						<Image
							src={APPLICATIONS_IMAGE}
							alt={t("hpdcApplicationsImageAlt")}
							fill
							className="object-cover"
							sizes="(max-width: 1024px) 100vw, 50vw"
							priority={false}
						/>
					</div>
				</div>
			</div>
		</section>
	);
}
